import { useMemo } from "react";

export function Sparkles({
  className = "",
  size = 1,
  minSize = null,
  density = 120,
  opacity = 1,
  minOpacity = null,
  color = "#FFFFFF",
}) {
  const particles = useMemo(() => {
    return Array.from({ length: Math.max(24, Math.min(220, Math.floor(density / 8))) }, (_, index) => {
      const particleSize = Math.max(minSize || size / 2.5, Math.random() * size + 0.8);
      return {
        id: index,
        left: Math.random() * 100,
        top: Math.random() * 100,
        duration: 6 + Math.random() * 10,
        delay: Math.random() * 6,
        scale: 0.4 + Math.random(),
        particleSize,
        alpha: Math.max(minOpacity || opacity / 10, Math.random() * opacity),
      };
    });
  }, [density, minOpacity, minSize, opacity, size]);

  return (
    <div className={`pointer-events-none ${className}`} aria-hidden="true">
      {particles.map((particle) => (
        <span
          key={particle.id}
          className="absolute rounded-full animate-[sparkleFloat_var(--dur)_ease-in-out_infinite]"
          style={{
            left: `${particle.left}%`,
            top: `${particle.top}%`,
            width: `${particle.particleSize}px`,
            height: `${particle.particleSize}px`,
            opacity: particle.alpha,
            backgroundColor: color,
            filter: "blur(0.4px)",
            transform: `scale(${particle.scale})`,
            ["--dur"]: `${particle.duration}s`,
            animationDelay: `${particle.delay}s`,
          }}
        />
      ))}
    </div>
  );
}